<script setup>
import {onMounted, onUnmounted, ref} from "vue";

const emit = defineEmits(['step', 'select']);
const {value, pass} = defineProps(['value', 'pass']);

const period = ref(value);

function select(new_value) {
    period.value = new_value;
}

function next() {
    const selected_pass = pass.find( item => item.subscription_period === period.value );

    if ( selected_pass.items.length <= 1 ) {
        emit('step', 'account');
    } else {
        emit('step', 'fitness-formulas');
    }

    emit('select', period.value);
}

const computeHeights = () => {
    let sameHeightsValues = {};
    let sameHeights = document.querySelectorAll("[data-same-height]");

    sameHeightsValues = {};

    sameHeights.forEach( el => {
        el.style.removeProperty('height');

        const group = el.getAttribute('data-same-height');

        if ( ! sameHeightsValues[ group ] ) {
            sameHeightsValues[ group ] = 0;
        }

        let height = el.offsetHeight;

        if ( height > sameHeightsValues[ group ] ) {
            sameHeightsValues[ group ] = height;
        }
    } );

    sameHeights.forEach( el => {
        const group = el.getAttribute('data-same-height');
        const minWidth = el.getAttribute('data-same-height-min-width') || 0;

        if ( parseInt( minWidth ) <= window.innerWidth ) {
            el.style.height = sameHeightsValues[ group ] + "px";
        }
    } );
};

onMounted( () => {
    computeHeights();
    window.addEventListener('resize', computeHeights );

    setTimeout( () => computeHeights(), 400 );
} );

onUnmounted( () => {
    window.removeEventListener('resize', computeHeights );
} );

</script>

<template>
    <div class="flex flex-col">
        <div class="flex flex-col lg:flex-row mb-10">
            <div class="mb-10 lg:mb-0">
                <button class="button-invert px-5 py-2" type="button" @click="emit('step', 'previous')"><i class="fa-solid fa-angle-left | mr-2"></i> Retour</button>
            </div>
            <h2 class="text-white text-4xl text-center lg:w-10/12">Période d'abonnement</h2>
        </div>

        <div class="overflow-scroll mb-10">
            <div class="flex flex-row gap-x-5 w-[200vw] sm:w-[200vw] md:w-[150vw] lg:w-[100vw] xl:w-full 2xl:w-full">
                <div v-for="item in pass"
                     class="subscription-period | flex flex-col flex-1 p-5 text-white transition-colors bg-dark border border-fitness rounded-2xl"
                     :class="{
                        'bg-zinc-500/20': period === item.subscription_period,
                    }">
                    <h3 class="text-fitness font-bold text-2xl mb-2" v-html="item.title" data-same-height="title"></h3>
                    <div class="text-lg font-bold mb-2" v-if="item.prices.length > 1">A partir de {{ item.prices[0] }} &euro;</div>
                    <div class="text-lg font-bold mb-2" v-if="item.prices.length <= 1">{{ item.prices[0] }} &euro;</div>
                    <div class="border-b border-fitness pb-2 mb-5">Fitness uniquement</div>

                    <ul class="mb-5 flex flex-col gap-y-2" data-same-height="details">
                        <li v-for="detail in item.details"><i class="fa-fw fa-solid fa-check text-fitness"></i> {{ detail }}</li>
                    </ul>

                    <button :class="{
                        'button-invert': period !== item.subscription_period,
                        'button': period === item.subscription_period,
                    }" class="px-5 py-2" type="button" @click="select(item.subscription_period)">Sélectionner</button>
                </div>
            </div>
        </div>

        <div class="text-center">
            <button class="button px-5 py-3" type="button" @click="next" :disabled="! period">Suivant <i class="fa-solid fa-angle-right | ml-2"></i></button>
        </div>
    </div>
</template>